// @flow
import platform from 'platform';

const isMac = platform.os.family === 'OS X';

const isMetaOrCtrl = ev => {
  return (!isMac && ev.ctrlKey) || (isMac && ev.key === 'Meta');
};

export const onkeydown = (ev: any) => (dispatch: Function, getState: Function) => {
  const id = Date.now();
  window.onblur = () => dispatch({ type: 'META_UP' });
  if (isMetaOrCtrl(ev)) {
    dispatch({ type: 'META_DOWN', id });
  }
  setTimeout(() => {
    if (getState().scribeTranscriptUI.metaDown === id) {
      dispatch({ type: 'DISPLAY_SHORTCUTS', id });
    }
  }, 300);
};

export const onkeyup = (ev: any) => (dispatch: Function) => {
  if (isMetaOrCtrl(ev)) {
    dispatch({ type: 'META_UP' });
  }
};
